import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  type TablePreferencesConfig,
} from 'src/common/ui/TablePreferences';

import { TRACK_PAGE_SIZE } from '../constants';

/**
 * Configs for the two Track tables; ids and order mirror `columns.tsx`. Separate
 * keys because the column sets only partly overlap. Nothing is pinned last —
 * Track has no CSS-pinned actions column.
 */

const PAGE_SIZE = {
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
  defaultPageSize: TRACK_PAGE_SIZE,
} as const;

/**
 * Namespace starts hidden: reaching either table means filtering by namespace
 * first, so it repeats one value per row. Still in the gear, returning last.
 */
const DEFAULT_HIDDEN = {
  defaultHiddenColumnIds: ['namespace'],
} as const;

export const ACTIVE_JOBS_PREFERENCES: TablePreferencesConfig = {
  storageKey: 'LangHub-trackTablePreferences-ACTIVE',
  columnOptions: [
    { id: 'stringGroup', label: 'String Group' },
    { id: 'version', label: 'Version' },
    { id: 'dueDate', label: 'Due Date' },
    { id: 'sentForTranslation', label: 'Sent on' },
    { id: 'status', label: 'Status' },
    { id: 'trackingId', label: 'Tracking ID' },
    { id: 'clientId', label: 'Ingestion Source' },
    { id: 'namespace', label: 'Namespace' },
  ],
  ...PAGE_SIZE,
  ...DEFAULT_HIDDEN,
};

export const HISTORICAL_JOBS_PREFERENCES: TablePreferencesConfig = {
  storageKey: 'LangHub-trackTablePreferences-HISTORICAL',
  columnOptions: [
    { id: 'stringGroup', label: 'String Group' },
    { id: 'version', label: 'Version' },
    { id: 'deliveredOn', label: 'Delivered On' },
    { id: 'sentOn', label: 'Sent on' },
    { id: 'turnaround', label: 'TAT' },
    { id: 'status', label: 'Status' },
    { id: 'trackingId', label: 'Tracking ID' },
    { id: 'clientId', label: 'Ingestion Source' },
    { id: 'namespace', label: 'Namespace' },
  ],
  ...PAGE_SIZE,
  ...DEFAULT_HIDDEN,
};
